import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setBeefManureStorage, setBeefManureStorageAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_MANURE_STORAGE } from "consts";

import { UploadableBeefManureStorage } from "models";

export const useMutateFootprintingBeefManureStorage = (primaryDataId: string, farmId: string, year: number) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation<UploadableBeefManureStorage[], Error, UploadableBeefManureStorage[]>({
    mutationKey: [FOOTPRINTING_BEEF_MANURE_STORAGE, primaryDataId, isAdmin],
    mutationFn: (data) => (isAdmin ? setBeefManureStorageAdmin(primaryDataId, data) : setBeefManureStorage(primaryDataId, data)),
    onSuccess: () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_BEEF_MANURE_STORAGE, primaryDataId, isAdmin],
        ...footprintingBeefPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
